module.exports = __webpack_public_path__ + "static/img/cyfw_index_02.44ee89e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cyfw_index_02.png
// module id = 7GG9
// module chunks = 1